import Vue from "vue";

// When the request succeeds
const success = (context) => {
  context.smallLoading = false;
};

// When the request fails
const failed = (error, context) => {
  context.smallLoading = false;
  context.showToasterError(error);
};

export default (user, context) => {
  Vue.$http
    .post("/user/resend-2fa-code-by-sms", user)
    .then((response) => {
      if (typeof response === "undefined") {
        failed(response.data.msg, context);
      } else {
        if (response.status === 201) {
          success(context, response);
        } else {
          failed(response.data.msg, context);
        }
      }
    })
    .catch((error) => {
      if (error) {
        failed(error, context);
      }
    });
};



// WEBPACK FOOTER //
// ./src/app/services/auth/resend2faCodeBySms.js